'use strict';

export default ['$resource', function($resource) {
    return $resource('api/ownership-forms/:ownershipFormId', null, {
        getAll: {method: 'GET'},
        get: {method: 'GET'},
        create: {url: 'api/ownership-forms/:ownershipFormId/create', method: 'POST'},
        update: {url: 'api/ownership-forms/:ownershipFormId/update', method: 'POST'},
        remove: {url: 'api/ownership-forms/:ownershipFormId/delete-logically', method: 'POST'},
        enable: {url: 'api/ownership-forms/:ownershipFormId/recovery', method: 'POST'},
        delete: {url: 'api/ownership-forms/:ownershipFormId/delete', method: 'POST'},
        getDefault: {url: 'api/ownership-forms/default', method: 'GET'},
        setDefault: {url: 'api/ownership-forms/:ownershipFormId/default', method: 'POST'},
        isUniqueName: {url: 'api/ownership-forms/unique/name/:name', method: 'GET'},
        exists: {url: 'api/ownership-forms/exists', method: 'GET'},
    });
}];
